export const isBaseLocationSet = (user?: Users.User) => {
  const isBaseLocationSet = Boolean(user?.baseLocation && user.baseLocation.id);

  return isBaseLocationSet;
};

